import React, { useMemo } from "react";
import styles from "./draggable-items.module.scss";
import classnames from "classnames";
import { Icon } from "..";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";

const DraggableItems = ({
  name,
  title,
  className,
  items = [],
  render,
  onChange,
  disableTabIndex = false,
  hasRemove = true,
}) => {
  const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    return result;
  };

  const getItemStyle = (isDragging, draggableStyle) => ({
    userSelect: "none",
    boxShadow: isDragging ? "0px 0px 10px #9E9E9E" : "",
    borderRadius: isDragging ? "3px" : "",
    padding: isDragging ? "30px 30px 30px 30px" : "",
    background: isDragging ? "#ffffff" : "",
    ...draggableStyle,
  });

  const onDragEnd = (result) => {
    if (!result.destination) {
      return;
    }
    const reordered = reorder(items, result.source.index, result.destination.index);
    onChange(name, {
      value: reordered,
    });
  };

  const getListStyle = (isDraggingOver) => ({
    background: isDraggingOver ? "" : "",
  });

  const renderItems = useMemo(() => {
    if (render) {
      return render;
    }
    return items;
  }, [items, render]);

  return (
    <div className={classnames("label-items", styles.container, className)}>
      <div className={styles.header}>
        {title}
        <DragDropContext onDragEnd={onDragEnd}>
          <Droppable droppableId="droppable" className={styles.droppable}>
            {(provided, snapshot) => (
              <div
                {...provided.droppableProps}
                ref={provided.innerRef}
                style={getListStyle(snapshot.isDraggingOver)}
              >
                {renderItems.map((item, index) => (
                  <Draggable key={item.id} draggableId={item.id} index={index}>
                    {(provided, snapshot) => (
                      <div
                        className={classnames(
                          styles.draggableItem,
                          item.className,
                          "draggableItem"
                        )}
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                        style={getItemStyle(snapshot.isDragging, provided.draggableProps.style)}
                        tabIndex={disableTabIndex ? -1 : 0}
                      >
                        <Icon name="drag" className={classnames(styles.dragIcon, "dragIcon")} />{" "}
                        {item.content}
                        {hasRemove && (
                          <div>
                            <Icon
                              name="trash"
                              className={classnames("ml-sm text-red")}
                              onClick={() => {
                                onChange(name, {
                                  value: items.filter((v, itemIndex) => {
                                    return index !== itemIndex;
                                  }),
                                });
                              }}
                            />
                          </div>
                        )}
                      </div>
                    )}
                  </Draggable>
                ))}
                {provided.placeholder}
              </div>
            )}
          </Droppable>
        </DragDropContext>
      </div>
    </div>
  );
};

export default DraggableItems;
